import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import ImageToVideo from './components/ImageToVideo';
import QRGenerator from './components/QRGenerator';
import ColorPicker from './components/ColorPicker';
import PasswordGenerator from './components/PasswordGenerator';
import ImageCompressor from './components/ImageCompressor';
import TextToSpeech from './components/TextToSpeech';
import ImageToPDF from './components/ImageToPDF';
import PDFToImages from './components/PDFToImages';
import VideoTrimmer from './components/VideoTrimmer';
import BackgroundRemover from './components/BackgroundRemover';
import AudioVisualizer from './components/AudioVisualizer';
import RegisterModal from './components/RegisterModal';
import './index.css';

const FreeTools = () => {
  const { toolName } = useParams();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleEnrollClick = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const renderTool = () => {
    switch (toolName) {
      case 'image-to-video':
        return <ImageToVideo />;
      case 'qr-generator':
        return <QRGenerator />;
      case 'color-picker':
        return <ColorPicker />;
      case 'password-generator':
        return <PasswordGenerator />;
      case 'image-compressor':
        return <ImageCompressor />;
      case 'text-to-speech':
        return <TextToSpeech />;
      case 'image-to-pdf':
        return <ImageToPDF />;
      case 'pdf-to-images':
        return <PDFToImages />;
      case 'video-trimmer':
        return <VideoTrimmer />;
      case 'background-remover':
        return <BackgroundRemover />;
      case 'audio-visualizer':
        return <AudioVisualizer />;
      default:
        return (
          <div style={{ padding: '100px 20px', textAlign: 'center' }}>
            <h1>Tool not found</h1>
            <p>Please select a tool from the Free Tools menu.</p>
          </div>
        );
    }
  };

  return (
    <div>
      <Navbar handleEnrollClick={handleEnrollClick} />
      {renderTool()}
      <RegisterModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default FreeTools;
